import { useTheme } from '@mui/material/styles';
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material';

interface DeliveryInfoFieldProps {
  label: string;
  value: React.ReactNode;
  sx?: SxProps<Theme>;
}

const DeliveryInfoField: React.FC<DeliveryInfoFieldProps> = ({ label, value, sx }) => {
  const theme = useTheme();
  return (
    <>
      <Typography
        sx={{
          fontWeight: 600,
          color: theme.palette.inputField.font,
          fontSize: '16px',
          minWidth: 120,
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          color: theme.palette.inputField.font,
          fontSize: '16px',
          fontWeight: 400,
          mt: 1,
          ...sx,
        }}
      >
        {value}
      </Box>
    </>
  );
};

export default DeliveryInfoField;
